import { createContext } from 'react';

type EditAiInstructionContextType = {
  showEditAiInstruction: boolean;
  setShowEditAiInstruction: Function;
  forwardOnModalCloseRef?: React.MutableRefObject<Function>;
  aiRolePlayId: number | null;
};

const EditAiInstructionContext = createContext<EditAiInstructionContextType>({
  showEditAiInstruction: false,
  setShowEditAiInstruction: () => {},
  forwardOnModalCloseRef: null,
  aiRolePlayId: null,
});

export default EditAiInstructionContext;
